import { Component, OnInit } from '@angular/core';
import { AlertService } from '../../_services/alert.service';
import { ApiIntegration } from '../../_services/api.integration';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { Globals } from '../../_models/globals';
import { User } from '../../_models/user';
import * as _ from "lodash";
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-admin-user-create',
  templateUrl: './admin-user-create.component.html',
  styleUrls: ['./admin-user-create.component.css']
})
export class AdminUserCreateComponent implements OnInit {
  //groupList: any;
  auth: any;
  role = {
    name: "",
  };
  selectedRole = {
    userRole: "",
  };
  selectedRoles = [];
  statusText1: string = "";
  statusText2: string = "";
  statusText3: string = "";
  statusText4: string = "";
  firstName: string;
  lastName: string;
  mobileNumber: string;
  email: string;

  constructor(private alertService: AlertService, private user: User, private http: HttpClient, private router: Router, private g: Globals, private api: ApiIntegration) {
    this.g.page = "User Create";
    this.g.loaderDisplay = "display";
    this.getApi();
  }

  getApi() {
    this.api.getUserAuthorities().subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.auth = data;
    }, err => {
      this.g.loaderDisplay = "";
      this.alertService.error('Error', err);
    });

  }
  click() {
    if (this.role.name != "") {
      this.selectedRole.userRole = this.role.name;
      this.selectedRoles.push(_.cloneDeep(this.selectedRole));
      this.role.name = "";
    }
  }


  ngOnInit() {
  }

  validateEmail() {
    this.statusText4 = "";
    this.typeEmail();
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    this.http.post(environment.apiUrl + 'api/uniqueEmail?email=' + this.email + "userType=" + "USER",
      { headers: header1 }).subscribe(data => {
        if (data['code'] == 200) {
        } else {
          if (data['code'] == 400) {
            this.statusText4 = data['message'];
          }
        }
      },
        (err: HttpErrorResponse) => {
          console.log(err);
          this.statusText4 = "uniqueEmail Failed, please re-try.";
        }
      )
  }

  validateMobile() {
    this.statusText3 = "";
    this.typeMobile();
    if (this.mobileNumber !== 'undefined') {
      var header1 = new HttpHeaders();
      header1 = header1.append('Content-Type', 'application/json');
      header1 = header1.append('Accept', 'application/json');
      this.http.post(environment.apiUrl + 'api/uniqueMobileNumber',
        this.mobileNumber,
        { headers: header1 }).subscribe(data => {
          if (data['code'] == 200) {

          } else {
            if (data['code'] == 400) {
              this.statusText3 = data['message'];
            }
          }

        },
          (err: HttpErrorResponse) => {
            console.log(err);
            this.statusText3 = "Mobile Number  Exists";
          }
        )
    }
  }

  removeProduct(rp) {
    let index = this.selectedRoles.indexOf(rp);
    this.selectedRoles.splice(index, 1);
  }


  typeFirstName() {
    this.statusText1 = "";
    if (this.firstName == '' || this.firstName === null || this.firstName === undefined || this.firstName === 'undefined') {
      this.statusText1 = 'Please enter first name';
    }
  }

  typeLastName() {
    this.statusText2 = "";
    if (this.lastName == '' || this.lastName === null || this.lastName === undefined || this.lastName === 'undefined') {
      this.statusText2 = 'Please enter last name';
    }
  }

  typeMobile() {
    //this.statusText3="";
    if (this.mobileNumber == '' || this.mobileNumber === null || this.mobileNumber === undefined || this.mobileNumber === 'undefined') {
      this.statusText3 = 'Please enter phone number';
      return false;
    } else if (this.mobileNumber.length != 10) {
      this.statusText3 = 'phone number must be minimum 10 characters';
      return false;
    }
    let i = this.mobileNumber.indexOf('0');
    if (i == 0) {
      this.statusText3 = "Number should not start with 0";
      return false;
    }
    return true;
  }

  typeEmail() {
    // this.statusText4="";
    if (this.email == '' || this.email === null || this.email === undefined || this.email === 'undefined') {
      this.statusText4 = 'Please enter email address';
      return false;
    }
    return true;
  }

  submit() {
    this.g.loaderDisplay = "display";
    this.statusText1 = "";
    this.statusText2 = "";
    this.statusText3 = "";
    this.statusText4 = "";

    if (this.firstName == '' || this.firstName === null || this.firstName === undefined || this.firstName === 'undefined') {
      this.statusText1 = 'Please enter first name';
    }
    if (this.lastName == '' || this.lastName === null || this.lastName === undefined || this.lastName === 'undefined') {
      this.statusText2 = 'Please enter last name';
    }
    if (this.mobileNumber == '' || this.mobileNumber === null || this.mobileNumber === undefined || this.mobileNumber === 'undefined') {
      this.statusText3 = 'Please enter phone number';
    } else if (this.mobileNumber.length != 10) {
      this.statusText3 = 'phone number must be minimum 10 characters';
    }
    if (this.email == '' || this.email === null || this.email === undefined || this.email === 'undefined') {
      this.statusText4 = 'Please enter email address';
    }

    if (this.statusText1 != "" || this.statusText2 != "" || this.statusText3 != "" || this.statusText4 != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));

    this.http.post(environment.apiUrl + 'api/createAdminUsers', {

      "email": this.email,
      "firstName": this.firstName,
      "lastName": this.lastName,
      "mobile": this.mobileNumber,
      "organizationId": "1",
      "role": this.selectedRoles

    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('User', 'Created Successfully');
          this.router.navigate(['/admin/userList']);
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          //this.alertService.error('Error',data['message']);
        });
  }

}
